import React, { PureComponent } from 'react'
import './input.scss'

const INPUT_FIELD_LENGTH = 60

export default class Input extends PureComponent {
  static defaultProps = {
    onChange: () => {},
    placeholder: '',
    type: 'text',
    error: '',
    success: '',
    name: '',
    bgImgPath: '',
    errorBgImgPath: '',
    value: '',
    testId: ''
  }

  render() {
    const {
      placeholder,
      onChange,
      type,
      error,
      success,
      name,
      onKeyPress,
      bgImgPath,
      errorBgImgPath,
      value,
      testId
    } = this.props

    const additionalProps = {}
    if (value) {
      additionalProps.value = value
    }

    return (
      <div className={`input-wrap ${error ? 'error' : ''}`}>
        <input
          style={{ backgroundImage: `url(${error ? errorBgImgPath : bgImgPath})` }}
          className={`${bgImgPath ? 'has-bg-img' : ''}`}
          name={name}
          maxLength={INPUT_FIELD_LENGTH}
          placeholder={placeholder}
          onChange={onChange}
          type={type}
          onKeyPress={(e) => {
            onKeyPress && onKeyPress(e)
          }}
          data-testid={testId}
          {...additionalProps}
        />
        {error && <div className='error-message'>{error}</div>}
        {success && <div className='success-message'>{success}</div>}
      </div>
    )
  }
}
